<template>
  <div class="search-bar-container">
    <input
        class="search-bar"
        type="text"
        :placeholder="placeholderText || 'search'"
        v-model="searchText"
        @input="validateSearch">
    <div class="error-message">{{searchError}}</div>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
    props: {
      clearSearch: Boolean,
      placeholderText: String,
      sectionType: String,
      isDebounce: Boolean,
      duration: {
        default: 500,
        type: Number
      }
    },

    name: 'SearchBar',

    data() {
      return {
        searchText: null,
        searchError: null
      }
    },

    created() {
      this.debounce = _.debounce(this.debounce, this.duration);
    },

    methods: {
      debounce() {
        this.getSearchResults()
      },

      getSearchResults() {
        this.$emit('getSearchResult', this.sectionType, this.searchText)
        this.searchError = null
      },

      validateSearch() {
        if (this.searchText && this.searchText.length > 150) {
          this.searchError = 'search text cannot be more than 150 characters'
        } else {
          this.isDebounce ? this.debounce() : this.getSearchResults()
        }
      }
    },

    watch: {
      clearSearch: function () {
        this.clearSearch ? this.searchText = null : null
      },
    },
  }
</script>

<style lang="sass">
@import '../../assets/sass/colors'

.search-bar
  border-radius: 32px
  border: 1px solid $primary-color
  font-size: 1rem
  margin-bottom: .5rem
  padding: .5rem 1rem
  width: 75%

</style>